import axios from 'axios'

export const GetTenantVersion = async () => {
    return await axios.get(`/About/GetTenantVersion`)
}
